import React from 'react';
import { user_token } from '../../../services/Auth';
import GetAge from './GetAge';
import api from "./../../../services/api";

//import da API
import { professional } from './../../../services/api'
let apiProfessional = new professional();

var token = localStorage.getItem(user_token);

export default class GetUser extends React.Component {
  state = {
    user: [],
    //   birth: this.props._id,
  }

  componentDidMount() {
    apiProfessional.getUser(this.props.user_id)
      //api.get(`/user/${this.props.user_id}`, { headers: { 'x-access-token': token } })
      .then(res => {
        const user = res.data;
        this.setState({ user });
      })
  }

  //console.log(calculate_age(new Date(1980, 11, 4)));  

  render() {

    // alert();

    return (
      <ul>

        {this.state.user.map(details =>
          <>
            <p id="RI-Title-Cadastro-Paciente" >ID do(a) Paciente: </p><p>{details.numericID}</p>
            <p id="RI-Title-Cadastro-Paciente" >Nome do(a) Paciente: </p><p>{details.name}</p>
            {details.user_type === "Paciente" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Paciente da instituição</p></> :
              details.user_type === "Funcionario" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Funcionário da instituição</p></> :
                null}
            <p id="RI-Title-Cadastro-Paciente" >Endereço do(a) Paciente: </p><p>{details.adress}</p>
            <p id="RI-Title-Cadastro-Paciente" >CPF do(a) Paciente: </p><p>{details.cpf}</p>
            <p id="RI-Title-Cadastro-Paciente" >Idade do(a) Paciente: </p><p><GetAge birth={details.birth} /> anos</p>
            <p id="RI-Title-Cadastro-Paciente" >Genêro do(a) Paciente: </p><p>{details.gender}</p>
          </>)}
      </ul>
    )
  }
}

